import { render, staticRenderFns } from "./userWalletDetails.vue?vue&type=template&id=95a9204e&scoped=true"
import script from "./userWalletDetails.vue?vue&type=script&lang=js"
export * from "./userWalletDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95a9204e",
  null
  
)

export default component.exports